import * as api from '../../../requests'
import {
  SET_BATCH_REPORT,
  SET_RECONCILE_USERS,
  SET_PAYMENT_BATCHES,
  SET_BATCH_INFO,
  SET_BATCH_NUMBERS,
} from './ReconcileReducer'
import { setErrorToast, setSuccessToast /*setSuccessToast*/ } from '../../../actions'
import { base64ToArrayBuffer } from '../ReceiptValidation/ReceiptValidationActions'

export const getReconcileUsers = () => {
  return (dispatch) => {
    api.GET_RECONCILE_USERS(
      (users) => dispatch({ type: SET_RECONCILE_USERS, users }),
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
      }
    )
  }
}

export const getPaymentBatches = (appUserID) => {
  return (dispatch) => {
    api.GET_PAYMENT_BATCHES(
      appUserID,
      0,
      (batches) => dispatch({ type: SET_PAYMENT_BATCHES, batches }),
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
      }
    )
  }
}

export const getBatchInfoByReceiptItemType = (appUserID, batchTypeID) => {
  return (dispatch) => {
    api.GET_PAYMENT_BATCHES(
      appUserID,
      batchTypeID,
      (batchInfo) => {
        dispatch({ type: SET_BATCH_INFO, batchTypeID, batchInfo })
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
      }
    )
  }
}

export const reconcileBatches = (appUserID, callback) => {
  return (dispatch, getState) => {
    const { selectedBatches, batches, batchInfo } = getState().reconcile
    let promiseArray = []

    batches
      .filter((batch) => selectedBatches.includes(batch.id))
      .forEach((batch) => {
        promiseArray.push(
          new Promise((resolve, reject) => {
            let ActualAmount = []

            if (batchInfo[batch.id]) {
              batchInfo[batch.id].forEach((info) => {
                ActualAmount.push(
                  info.AmountOnHand ? Number(info.AmountOnHand.replace(',', '')) : Number(0)
                )
              })
            }

            const batchPayload = {
              BatchTypeID: batch.ID,
              AppUserID: appUserID,
              ActualAmount,
            }

            api.RECONCILE_BATCH(
              batchPayload,
              (data) => {
                resolve(data)
              },
              (err) => {
                reject(err)
              }
            )
          })
        )
      })

    Promise.all(promiseArray)
      .then((values) => {
        dispatch({
          type: SET_BATCH_NUMBERS,
          batchNums: [...(values || []).map((val) => val.BatchNumber)],
        })
        dispatch(setSuccessToast('Successfully reconciled selected batches.'))
        callback()
      })
      .catch((err) => {
        console.error(err)
        dispatch(setErrorToast(err))
        callback(err)
      })
  }
}

export const getBatchReport = (appUserID) => {
  return (dispatch, getState) => {
    api.GET_BATCH_REPORT(
      appUserID,
      (batchReports) => {
        dispatch({ type: SET_BATCH_REPORT, batchReports })
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
      }
    )
  }
}

export const getPrintableBatchReport = (appUserID, batchNum, callback, errorCallback) => {
  return () => {
    api.GET_PRINTABLE_BATCH_REPORT(
      appUserID,
      batchNum,
      (data) => {
        const arrrayBuffer = base64ToArrayBuffer(data)
        const blob = new Blob([arrrayBuffer], { type: 'application/pdf' })
        const link = window.URL.createObjectURL(blob)
        window.open(link, '_blank')
        // console.log('what???', data);
        callback()
      },
      (err) => {
        console.error(err)
        errorCallback()
      }
    )
  }
}
